import { api } from './api';
import { accountStore, syncPaused } from './storage';
import type { DashboardData, SyncResult } from './types';

export async function downloadAccount(userId: string, token: string) {
  const store = accountStore(userId);
  await store.mergeRemote(await api.dashboard(token, await store.deviceId()));
  return store.snapshot();
}
const running = new Map<string, Promise<{ data: DashboardData; conflicts: number }>>();
export function synchronizeAccount(userId: string, token: string) {
  const existing = running.get(userId); if (existing) return existing;
  const operation = async () => {
    if (syncPaused(userId)) throw new Error('local_sync_paused');
    const store = accountStore(userId); const deviceId = await store.deviceId();
    const remote = await api.dashboard(token, deviceId);
    await store.mergeRemote(remote);
    const local = await store.snapshot(); const attempts = local.attempts.filter((row) => row.syncState !== 'synced' && row.syncState !== 'conflict');
    const remoteProgress = new Map(remote.progress.map((row) => [row.key, row]));
    const progress = local.progress.filter((row) => (row.deviceSeen || 0) > (remoteProgress.get(row.key)?.deviceSeen || 0) || (row.deviceCorrect || 0) > (remoteProgress.get(row.key)?.deviceCorrect || 0));
    const remoteBookmarks = new Map(remote.bookmarks.map((row) => [row.key, row]));
    const bookmarks = local.bookmarks.filter((row) => row.changeId !== remoteBookmarks.get(row.key)?.changeId);
    const result: SyncResult = { synced: [], conflicts: [] };
    const batches = Math.max(Math.ceil(attempts.length / 5), Math.ceil(progress.length / 100), Math.ceil(bookmarks.length / 100));
    for (let i = 0; i < batches; i++) {
      store.assertCurrent();
      const part = await api.syncState(attempts.slice(i * 5, i * 5 + 5), progress.slice(i * 100, i * 100 + 100).map((row) => ({ ...row, deviceSeen: row.deviceSeen || 0, deviceCorrect: row.deviceCorrect || 0 })), bookmarks.slice(i * 100, i * 100 + 100), deviceId, token);
      result.synced.push(...part.synced); result.conflicts.push(...part.conflicts);
    }
    if (batches) await store.mergeRemote(await api.dashboard(token, deviceId), result);
    const data = await store.snapshot(); return { data, conflicts: data.attempts.filter((row) => row.syncState === 'conflict').length };
  };
  const promise = operation().finally(() => running.delete(userId)); running.set(userId, promise); return promise;
}
